import { Controller } from "@hotwired/stimulus";

// Warns before leaving an in-progress search/reservation via the header
// logo (see layouts/flygcity_responsive.html.erb -- only rendered on
// step1-4 pages). "Lämna bokningen" is a plain link (real navigation,
// same tab); this controller only ever intercepts the logo's own click
// to show that choice first.
export default class extends Controller {
  static targets = ["modal"];

  confirm(event) {
    event.preventDefault();
    this.modalTarget.classList.remove("hidden");
    this.modalTarget.classList.add("flex");
  }

  cancel() {
    this.modalTarget.classList.add("hidden");
    this.modalTarget.classList.remove("flex");
  }

  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) this.cancel();
  }
}
